import { Controller } from "@hotwired/stimulus"
import { Carousel } from "flowbite"

export default class extends Controller {
  static targets = [
    "slide", "prevButton", "nextButton"
  ]

  connect() {
    this.items = this.slideTargets.map((target, index) => ({position: index, el: target}))
    this.carousel = new Carousel(this.element, this.items, {}, {})
    this.currentIndex = 0
    this.prevButtonTarget.disabled = true
  }

  next() {
    if (this.currentIndex < this.items.length - 1) {
      this.carousel.next()
      this.currentIndex++
      this.updateButtonStates()
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.carousel.prev()
      this.currentIndex--
      this.updateButtonStates()
    }
  }

  updateButtonStates() {
    this.prevButtonTarget.disabled = this.currentIndex === 0
    this.nextButtonTarget.disabled = this.currentIndex === this.items.length - 1
  }
}
